import React, { Component } from 'react';
import { SiteTitle } from "./SiteTitle";
import { Row, Col, Card, CardImg, CardText, CardBody, CardTitle, CardSubtitle } from 'reactstrap';
import "./TotalCss.css";

export class PageCiaInfo extends Component {
  static displayName = PageCiaInfo.name;

  render() {
    return (
      <div>
        <SiteTitle />
        <div className="mt-5">
          <h1 id="tableLabel" className='mb-3'>弱點掃描服務平台 組織結構</h1>
          <div id="site_manage" className="row col-12">
            <div className="row justify-content-center">
              <Row className='d-flex justify-content-center mb-5'>
                <Card className='col-5 shadow' style={{ backgroundColor: '#FB966E' }}>
                  <CardBody>
                    <CardTitle className='text-white h4'>單位名稱：竹苗區網中心</CardTitle>
                    <CardText>網址：https://www.hcrc.edu.tw</CardText>
                    <CardText>地址：300新竹市大學路1001號</CardText>
                    <CardText>傳真：03-5714031</CardText>
                  </CardBody>
                </Card>
              </Row>
              <Row className='d-flex justify-content-center mb-5'>
                <Card className='col-5 shadow' style={{ backgroundColor: '#FB966E' }}>
                  <CardBody>
                    <CardTitle className='text-white h4'>單位主管：施仁忠 主任</CardTitle>
                    <CardText>E-mail：zcshih@cs.nycu.edu.tw</CardText>
                    <CardText>電話：03-5731900</CardText>
                  </CardBody>
                </Card>
              </Row>
              <Row className='d-flex justify-content-center mb-5'>
                <Card className='col-5 shadow' style={{ backgroundColor: '#FB966E' }}>
                  <CardBody>
                    <CardTitle className='text-white h4'>單位負責人：高義智 組長</CardTitle>
                    <CardText>E-mail：ykao@nycu.edu.tw</CardText>
                    <CardText>電話：03-5731905</CardText>
                  </CardBody>
                </Card>
              </Row>
              <Row className='d-flex justify-content-around mb-5'>
                <Card className='col-4  shadow mr-5' style={{ backgroundColor: '#FB966E' }}>   <CardBody className='mr-5'>
                  <CardTitle className='text-white h4'>網管負責人：廖柏硯</CardTitle>
                  <CardText>E-mail：bo1206@nycu.edu.tw</CardText>
                  <CardText>電話：03-5712121#52858</CardText>
                </CardBody>
                </Card>
                <Card className='col-4  shadow mr-5' style={{ backgroundColor: '#FB966E' }}>  <CardBody>
                  <CardTitle className='text-white h4'>系統維護：許世平</CardTitle>
                  <CardText>E-mail：business255work@nycu.edu.tw</CardText>
                  <CardText>電話：03-5712121#52856</CardText>
                </CardBody>
                </Card>
              </Row>
              <Row className='d-flex justify-content-around mb-5'>
                {/* <Card className='col-4  shadow mr-5' style={{ backgroundColor: '#FB966E' }}>    <CardBody className='mr-5'>
                  <CardTitle className='text-white h4'>資安負責人：何馨晴</CardTitle>
                  <CardText>E-mail：heather.sc@nycu.edu.tw</CardText>
                  <CardText>電話：03-5712121#52885</CardText>
                </CardBody>
                </Card> */}
                <Card className='col-4 orange-049 shadow mr-5' style={{ visibility: 'hidden' }}>
                  <CardBody className='mr-5'>
                    <CardTitle className='text-white h4'></CardTitle>
                    <CardText>E-mail：</CardText>
                    <CardText>電話：</CardText>
                  </CardBody>
                </Card>
                <Card className='col-4  shadow mr-5' style={{ backgroundColor: '#FB966E' }}>    <CardBody>
                  <CardTitle className='text-white h4'>系統維護：廖期鈞</CardTitle>
                  <CardText>E-mail：lio221@nycu.edu.tw</CardText>
                  <CardText>電話：03-5712121#31729</CardText>
                </CardBody>
                </Card>
              </Row>
              {/* <Row className='d-flex justify-content-around mb-5'>
                <Card className='col-4 orange-049 shadow mr-5' style={{ visibility: 'hidden' }}>
                  <CardBody className='mr-5'>
                    <CardTitle className='text-white h4'></CardTitle>
                    <CardText>E-mail：</CardText>
                    <CardText>電話：</CardText>
                  </CardBody>
                </Card>
                <Card className='col-4 orange-049 shadow mr-5'>
                  <CardBody>
                    <CardTitle className='text-white h4'>系統維護：許世平</CardTitle>
                    <CardText>E-mail：business255work@nycu.edu.tw</CardText>
                    <CardText>電話：03-5712121#52856</CardText>
                  </CardBody>
                </Card>
              </Row> */}

            </div>
          </div>
        </div>
      </div>
    )
  }
}